<template>
  <div>
    <!-- <div class="title f">
      <transition name="slideLeft" :duration="200"><q-btn @click="goBack" icon="mdi-chevron-left" v-if="$store.state.canGoBack" color="#000" flat style=""/></transition>
      <transition  name="bounce" :duration="200"> <b >{{title}} </b></transition>
    </div>
 -->
  <div id="my-menu" class="f fc" @mouseenter="showContent = true" @mouseleave="showContent = false">

    <div class="r" style="height: 40px">
      <div class="r">
        <h3>{{ $store.state.usr.name || 'no name' }}</h3>
      </div>
      <div style="position: relative; width: 50px; height: 50px;border-radius:25px;">
        <q-avatar
          style="position: absolute; right: 0; top: -2px; color: #fff;"
          size="55px"
          color="primary"
          >{{
            $store.state.usr.img?.src ||
            ($store.state.usr.name || '')
              .split(' ')
              .map((x) => x[0])
              .join('')
              .toUpperCase()
          }}</q-avatar
        >
      </div>
    </div>

    <div v-if="$store.state.usr.customData?.role?.admin" class="role">
      admin
    </div>

    <transition name="fade" leave-active-class="hide">
      <div class="content f fc" v-if="showContent">
        <div class="r fstart">
          <q-chip>{{  !$store.state.usr?.org ? 'admin' : $store.state.usr.org.role || 'editore' }}</q-chip>
        </div>
        <!-- <router-link to="/impostazioni"> <q-icon name="mdi-cog" /> IMPOSTAZIONI </router-link> -->
        <router-link class="f fw" to="/account"> <q-icon name="mdi-account" /> ACCOUNT </router-link>
        <a class="f fw" @click="logout" style="color: red"> <q-icon name="mdi-logout" /> LOGOUT </a>
      </div>
    </transition>
    </div>
    </div>
  <div>
</div>
</template>
<script>
export default {
  data: () => ({
    showContent: false,
    prova: false,
  }),
  computed:{
    title(){
      return this.$route.name
    }
  },
  methods:{
    logout(){
        this.$q.dialog({
        title: 'Conferma il logout',
          message: 'Vuoi davvero effettuare il logout?',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.commit('logout');
          //this.$router.push('/login');
        })
    }
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.hide {
  display: none;
}
.title {
  background-color: #dedede;
  font-weight: bold;
  position: absolute;
  top: 30px;
  padding:0 15px;
  border-radius: 13px;
  z-index: 9;;
  left: 240px;
  text-transform: uppercase;;
  font-size:18px;
  height: 40px;
}
#my-menu {
  background-color: #fff;
  border-radius: 20px;
  
  position: fixed;
  height: 40px;
  top: 20px;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  right: 5%;
  width: 240px;
  transition: height 0.27s ease-in-out, width 0.27s ease-in-out;
  box-shadow: -3px 3px 9px #0002;
  z-index: 9999;
  .role {
    position: absolute;background-color:#f33;padding:0px 20px;color:#fff;left:5%;bottom:50%;border-radius:10px;font-size:14px;transform:translate3d(-100%,50%,0);
  }
  h3 {
    color: #000;
    font-size: 20px;
    line-height: 1.22rem;
    padding: 0 40px;
    display: block;
    text-align: center;
    text-transform: capitalize;
  }
  .content {
    transition: opacity 0.4s ease-in-out;
    transition-delay: 0.4s;
    justify-content: flex-end;
    padding: 0 20px 20px;
    width: 100%;
    height: 100%;
    a {
      display: block;
      padding: 10px;
      color: #333;
      text-decoration: none;
      width: 100%;
      border-bottom: 1px solid #ccc;
      &:hover {
        background-color: #ddd;
      }
    }
  }
  &:hover {
    height: 160px;
    width: 400px;
    .content {
      opacity: 1;
    }
  }
}
</style>
